import { useCallback, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { StoreState } from 'store';
import { clearError, profileRequest } from 'features/user/redux/actions';
import { UserRole } from 'features/user/ts/UserRole';
import { User } from 'features/user/ts';

const getUserRolesTitle = (roles: UserRole[]) =>
  roles.reduce((acc, role, i) => `${acc + (i !== roles?.length - 1 ? ',' : '')}${role.readable_name}`, '');

const getUserFullName = ({ first_name, last_name }: User) =>
  first_name && last_name ? `${first_name} ${last_name}` : first_name ? first_name : last_name || '';

const useUser = () => {
  const dispatch = useDispatch();
  const { user, isLoading, error } = useSelector((state: StoreState) => state.user, shallowEqual);

  const userRolesTitle = useMemo(
    () => (!isLoading && user?.roles ? getUserRolesTitle(user.roles) : ''),
    [isLoading, user?.roles]
  );
  const userFullName = useMemo(() => (!isLoading && user ? getUserFullName(user) : ''), [isLoading, user]);

  const onProfile = useCallback(() => dispatch(profileRequest()), [dispatch]);

  const onClearError = useCallback(() => dispatch(clearError()), [dispatch]);

  return {
    user,
    userRolesTitle,
    userFullName,
    isLoading,
    error,
    onProfile,
    onClearError,
  };
};

export default useUser;
